import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache) {
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")
  const _component_CaseSolutionFields = _resolveComponent("CaseSolutionFields")
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")
  const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader")

  return (!_ctx.isLoading && _ctx.codeLevels)
    ? (_openBlock(), _createBlock(_component_v_expansion_panels, {
        key: 0,
        variant: "accordion"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.solutions, (solution, index) => {
            return (_openBlock(), _createBlock(_component_v_expansion_panel, {
              key: solution.caseCodeLevelSetId
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_expansion_panel_title, null, {
                  default: _withCtx(() => [
                    _createElementVNode("span", {
                      class: _normalizeClass(_ctx.isPrimary(solution) ? 'blue--text' : null)
                    }, _toDisplayString(_ctx.getSolutionName(solution)), 3)
                  ]),
                  _: 2
                }, 1024),
                _createVNode(_component_v_expansion_panel_text, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_CaseSolutionFields, {
                      solution: solution,
                      class: "my-4",
                      "onUpdate:solution": (s) => _ctx.updateSolution(index, s)
                    }, null, 8, ["solution", "onUpdate:solution"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }))
    : (_openBlock(), _createBlock(_component_v_skeleton_loader, {
        key: 1,
        loading: _ctx.isLoading,
        type: "table-row, table-row, table-row"
      }, null, 8, ["loading"]))
}